// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1EWM7","header":"ClearentDisclaimer_header__1qyNJ","inner":"ClearentDisclaimer_inner__3ljfw"};